import { Components, ModalUtils, Model, NeoModel, NotifyUtils } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { Data } from '@singularsystems/neo-core';
import RunInterceptionComponentVM from '../../../Common/Components/Interception/RunInterceptionComponentVM';
import { AppService, Types } from '../../../App/Services/AppService';
import TransactionInterceptionSearchCriteria from '../Models/Queries/TransactionInterceptionSearchCriteria';
import RawGenericTransactionLookup from '../Models/Lookups/RawGenericTransactionLookup';
import StaticServiceProviderFileGroupingModel from '../../../Common/Models/StaticServiceProviderFileGroupingModel';
import UpdateSecurityTransactionComponentVM from '../Components/UpdateSecurityTransactionComponentVM';
import { TextConstants } from '../../../Common/TextConstants';
import { NotificationDuration } from '../../../App/Models/Enums/NotificationDuration';
import UpdateTransactionCommand from '../Models/Commands/UpdateTransactionCommand';
import UpdateCashTransactionComponentVM from '../Components/UpdateCashTransactionComponentVM';
import TransactionSearchCriteria from '../../../Reports/Transactions/Models/Queries/TransactionSearchCriteria';
import FileDownloadComponentVM from '../../../Common/Components/FileDownload/FileDownloadComponentVM';
import UpdateTransactionModalCommand from '../Models/Commands/UpdateTransactionModalCommand';
import InstrumentSearchLookup from '../../InstrumentMapping/Models/InstrumentSearchLookup';
import ClientLookup from '../../ClientAccountMapping/Models/ClientLookup';
import StaticEventLookup from '../../EventMapping/Models/StaticEventSearchModal/StaticEventLookup';
import { StaticDataTypes } from '../../../Maintenance/StaticData/StaticDataTypes';
import CurrencyComponentVM from '../../../Common/Components/Currency/CurrencyComponentVM';

@NeoModel
export default class TransactionInterceptionVM extends Views.ViewModelBase {

    constructor(

        public fileDownloadApiClient = AppService.get(Types.ApiClients.FileDownloadApiClient),
        public generalApiClient = AppService.get(Types.ApiClients.GeneralApiClient),
        public transactionsApiClient = AppService.get(Types.ApiClients.TransactionsApiClient),
        public authorisableUpdateRequestApiClient = AppService.get(Types.ApiClients.AuthorisableUpdateRequestApiClient),
        private serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient),
        public taskRunner = AppService.get(Types.Neo.TaskRunner),
        private staticDataCache = AppService.get(StaticDataTypes.Services.StaticDataCache)) {
        super(taskRunner);
        this.csvModal = [];
        this.updateCashTransactionCommand = this.createCashUpdateTransactionCommand();
    }

    public transactionsSearchCriteria = new TransactionSearchCriteria();
    public fileDownloadVM = new FileDownloadComponentVM();
    public runInterceptionVM = new RunInterceptionComponentVM();
    public updateSecurityTransactionComponentVM = new UpdateSecurityTransactionComponentVM();
    public updateCashTransactionComponentVM = new UpdateCashTransactionComponentVM();
    public transactionInterceptionSearchCriteria = new TransactionInterceptionSearchCriteria();
    public displayUpdateSecurityTransactionComponent: boolean = false;
    public displayUpdateCashTransactionComponent: boolean = false;
    public displayTransactionInterceptionParent: boolean = true;
    public displayCashTransactionComponent: boolean = false;
    public serviceProviderGroupingName: string = "";
    public batchNotes = "";
    public csvSecurityNotes = ""
    public csvCashNotes = ""
    public showAuthModal: boolean = false;
    public showAuthModalCash: boolean = false;
    public showSecurityCSVModal: boolean = false;
    public showCashCSVModal: boolean = false;
    public updateSecurityTransactionCommand = new UpdateTransactionCommand();
    public updateCashTransactionCommand = new UpdateTransactionCommand();
    public updateTransactionModalCommand = new UpdateTransactionModalCommand();
    public selectedSecurityTransactions: RawGenericTransactionLookup[] = [];
    public selectedCashTransactions: RawGenericTransactionLookup[] = [];
    public isAuthorisation: boolean = false;
    public showSecurityTransactions: boolean = true;
    public showCashTransactions: boolean = true;
    public showLoader: boolean = false;
    public csvModal: File[];
    public instruments: Model.PlainObject<InstrumentSearchLookup>[] = [];
    public filteredInstruments: Model.PlainObject<InstrumentSearchLookup>[] = [];
    public serviceProviderFileGroupings: Model.PlainObject<StaticServiceProviderFileGroupingModel>[] = [];
    public filteredServiceProviderFileGroupings: Model.PlainObject<StaticServiceProviderFileGroupingModel>[] = [];
    public clientAccounts: Model.PlainObject<ClientLookup>[] = [];
    public filteredClientAccounts: Model.PlainObject<ClientLookup>[] = [];
    public events: Model.PlainObject<StaticEventLookup>[] = [];
    public filteredEvents: Model.PlainObject<StaticEventLookup>[] = [];
    public selectedAllSecurityTransactions: boolean = false;
    public selectedAllCashTransactions: boolean = false;
    public isBulkSelectAllSecurityTransactions: boolean = false;
    public isBulkSelectAllCashTransactions: boolean = false;
    public currencyComponentVM = new CurrencyComponentVM();

    public document: Nullable<Document> = null;

    public documentId: number | null = null;
    public fileDescriptorId: number | null = null;

    public pageManagerSecurity = new Data.PageManager(this.transactionInterceptionSearchCriteria, RawGenericTransactionLookup, this.transactionsApiClient.getTransactionInterceptionPagedList, {
        pageSize: 10,
        pageSizeOptions: [10, 20, 50, 100, 250],
        sortAscending: true,
        fetchInitial: false,
        initialTaskRunner: this.taskRunner,
        afterFetch: (result) => this.afterFetch(result, false),
    });

    public pageManagerCash = new Data.PageManager(this.transactionInterceptionSearchCriteria, RawGenericTransactionLookup, this.transactionsApiClient.getCashTransactionInterceptionPagedList, {
        pageSize: 10,
        pageSizeOptions: [10, 20, 50, 100, 250],
        sortAscending: true,
        fetchInitial: false,
        initialTaskRunner: this.taskRunner,
        afterFetch: (result) => this.afterFetch(result, true),
    });

    public async initialise() {
        await Promise.all([
            this.populateCurrencies(),
            this.populateServiceProviderFileGroupings(),
            this.populateClientAccounts(),
            this.populateEvents(),
            this.populateInstruments(),
            this.runInterceptionVM.initialise(),
        ]);
        this.updateSecurityTransactionComponentVM.events = this.events;
        this.updateSecurityTransactionComponentVM.filteredEvents = this.filteredEvents;
        this.updateSecurityTransactionComponentVM.instruments = this.instruments;
        this.updateSecurityTransactionComponentVM.filteredInstruments = this.filteredInstruments;
        this.updateCashTransactionComponentVM.events = this.events;
        this.updateCashTransactionComponentVM.filteredEvents = this.filteredEvents;
    }

    public refreshAllCards() {
        this.transactionInterceptionSearchCriteria.staticCurrencyId = this.currencyComponentVM.selectedCurrency.staticCurrencyId == 0 ? null : this.currencyComponentVM.selectedCurrency.staticCurrencyId;
        if (this.showSecurityTransactions) {
            this.pageManagerSecurity.refreshData();
        }
        if (this.showCashTransactions) {
            this.pageManagerCash.refreshData();
        }
    }

    public showUpdateSecurityTransactionComponent() {
        this.displayUpdateSecurityTransactionComponent = true;
        this.displayTransactionInterceptionParent = false;
        this.updateSecurityTransactionComponentVM.selectedSecurityTransactions = this.isBulkSelectAllSecurityTransactions
            ? this.selectedSecurityTransactions.filter(transaction => transaction.selected).slice(0, 10)
            : this.selectedSecurityTransactions;
    }

    public showUpdateCashTransactionComponent() {
        this.displayUpdateCashTransactionComponent = true;
        this.displayTransactionInterceptionParent = false;
        this.updateCashTransactionComponentVM.selectedCashTransactions = this.isBulkSelectAllCashTransactions
            ? this.selectedCashTransactions.filter(transaction => transaction.selected).slice(0, 10)
            : this.selectedCashTransactions;
    }

    public showSecurityTransactionsCSVModal() {
        this.showSecurityCSVModal = true;
        this.displayTransactionInterceptionParent = false;
    }

    public showCashTransactionsCSVModal() {
        this.showCashCSVModal = true;
        this.displayTransactionInterceptionParent = false;
    }

    public closeNoteModal() {
        this.showAuthModal = false;
        this.showAuthModalCash = false;
    }

    public closeCSVModal() {
        this.showSecurityCSVModal = false;
        this.showCashCSVModal = false;
        this.csvModal = [];
        this.displayTransactionInterceptionParent = true;
    }

    public saveNote() {
        this.isAuthorisation = true;
        this.showAuthModal = false;
        this.updateSecurityTransaction();
    }

    public saveNoteCash() {
        this.isAuthorisation = true;
        this.showAuthModalCash = false;
        this.updateCashTransaction();
    }

    public async backToTransaction() {
        this.displayUpdateSecurityTransactionComponent = false;
        this.displayUpdateCashTransactionComponent = false;
        this.displayTransactionInterceptionParent = true;
        this.pageManagerSecurity.refreshData();
        this.pageManagerCash.refreshData();
        this.selectedSecurityTransactions = [];
        this.selectedCashTransactions = [];
        this.selectedAllSecurityTransactions = false;
        this.updateSecurityTransactionSelectAllCheckbox(this.selectedAllSecurityTransactions);
        this.selectedAllCashTransactions = false;
        this.updateCashTransactionSelectAllCheckbox(this.selectedAllCashTransactions);
        this.updateSecurityTransactionCommand = new UpdateTransactionCommand();
        this.updateSecurityTransactionComponentVM.updateTransactionCommand = new UpdateTransactionCommand();
        this.updateCashTransactionCommand = this.createCashUpdateTransactionCommand();
        this.updateCashTransactionComponentVM.updateCashTransactionCommand = this.createCashUpdateTransactionCommand();
    }

    private createCashUpdateTransactionCommand(): UpdateTransactionCommand {
        const cashUpdateTransactionCommand = new UpdateTransactionCommand();
        cashUpdateTransactionCommand.transactionType = 2;
        return cashUpdateTransactionCommand;
    }

    public async populateCurrencies() {
        this.updateSecurityTransactionComponentVM.currencyComponentVM.getCurrenciesList();
        this.currencyComponentVM.getCurrenciesList();
    }

    public async populateInstruments() {
        this.instruments = await this.staticDataCache.instruments.getDataAsync()
            .then((arr) => arr.sort((x, y) => x.description!.localeCompare(y.description!)));
        this.filteredInstruments = this.instruments.slice(0, 10);
    }

    public async populateServiceProviderFileGroupings() {
        this.serviceProviderFileGroupings = await this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria()
            .then((arr) => arr.data.sort((x, y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)));
        this.filteredServiceProviderFileGroupings = this.serviceProviderFileGroupings.slice(0, 10);
    }

    public async populateClientAccounts() {
        this.clientAccounts = await this.staticDataCache.clientAccounts.getDataAsync()
            .then((arr) => arr.sort((x, y) => x.clientDescription.localeCompare(y.clientDescription)));
        this.filteredClientAccounts = this.clientAccounts.slice(0, 10);
    }

    public async populateEvents() {
        this.events = await this.staticDataCache.events.getDataAsync()
            .then((arr) => arr.sort((x, y) => x.staticEventName.localeCompare(y.staticEventName)));
        this.filteredEvents = this.events.slice(0, 10);
    }

    public async confirmTransactionUpdate() {
        this.updateSecurityTransactionCommand.updateNotes = "";
    }

    public showUserNotesModal() {
        this.showAuthModal = true;
    }

    public showUserNotesCashModal() {
        this.showAuthModalCash = true;
    }

    public async updateSecurityTransaction() {
        let userNotes = this.updateSecurityTransactionCommand.updateNotes;
        this.setupUpdateTransactionCommand(
            this.updateSecurityTransactionCommand,
            this.updateSecurityTransactionComponentVM.updateTransactionCommand,
            this.isBulkSelectAllSecurityTransactions,
            this.selectedSecurityTransactions,
            true,
            transaction => transaction.rawGenericSecurityTransactionID,
        );

        this.updateSecurityTransactionCommand.newStaticCurrencyId = this.updateSecurityTransactionComponentVM.currencyComponentVM.selectedCurrency.staticCurrencyId == 0 ? null : this.updateSecurityTransactionComponentVM.currencyComponentVM.selectedCurrency.staticCurrencyId;
        this.updateSecurityTransactionCommand.staticServiceProviderFileGroupingID = this.transactionInterceptionSearchCriteria.staticServiceProviderFileGroupingID;

        if (this.updateSecurityTransactionComponentVM.updateTransactionCommand.meta.newTime.value !== null) {
            this.updateSecurityTransactionCommand.newTimeString = this.updateSecurityTransactionComponentVM.updateTransactionCommand.meta.newTime.value.toTimeString().substring(0, 8);
        } else {
            this.updateSecurityTransactionCommand.newTimeString = null;
        }

        // Manual Validation Required.
        if (this.updateSecurityTransactionCommand.newStaticCurrencyId !== null && this.updateSecurityTransactionCommand.newStaticCurrencyId > 0 &&
            (this.updateSecurityTransactionCommand.updatePriceToBookCostInd == true ||
                (this.updateSecurityTransactionCommand.priceOverride !== null && this.updateSecurityTransactionCommand.priceOverride > 0))) {
            NotifyUtils.addDanger(TextConstants.Titles.FailedTransactionUpdate, TextConstants.Notifications.UnsuccessfulTransactionUpdate, NotificationDuration.Standard);
        }
        else {
            if (!this.isAuthorisation) {
                this.taskRunner.run(async () => {
                    await this.transactionsApiClient.updateSecurityTransactions(this.updateSecurityTransactionCommand!.toJSObject())
                    NotifyUtils.addSuccess(TextConstants.Titles.Success, TextConstants.Notifications.SuccessfulTransactionUpdate, NotificationDuration.Standard);
                });
            }
            else {
                this.taskRunner.run(async () => {
                    this.updateSecurityTransactionCommand.updateNotes = userNotes;
                    await this.authorisableUpdateRequestApiClient.createAuthorisableUpdateTransactions(this.updateSecurityTransactionCommand!.toJSObject())
                    NotifyUtils.addSuccess(TextConstants.Titles.AuthorisationRequest, TextConstants.Notifications.UpdateRequestCreated, NotificationDuration.Standard);
                });
            }

            await this.backToTransaction();
        }
    }

    public async updateCashTransaction() {
        let userNotes = this.updateCashTransactionCommand.updateNotes;
        this.setupUpdateTransactionCommand(
            this.updateCashTransactionCommand,
            this.updateCashTransactionComponentVM.updateCashTransactionCommand,
            this.isBulkSelectAllCashTransactions,
            this.selectedCashTransactions,
            false,
            transaction => transaction.rawGenericCashTransactionID,
        );

        this.updateCashTransactionCommand.staticServiceProviderFileGroupingID = this.transactionInterceptionSearchCriteria.staticServiceProviderFileGroupingID;

        // Manual Validation Required.
        if (!this.isAuthorisation) {
            this.taskRunner.run(async () => {
                await this.transactionsApiClient.updateCashTransactions(this.updateCashTransactionCommand!.toJSObject())
                NotifyUtils.addSuccess(TextConstants.Titles.Success, TextConstants.Notifications.SuccessfulTransactionUpdate, NotificationDuration.Standard);
            });
        }
        else {
            this.taskRunner.run(async () => {
                this.updateCashTransactionCommand.updateNotes = userNotes;
                await this.authorisableUpdateRequestApiClient.createAuthorisableUpdateCashTransactions(this.updateCashTransactionCommand!.toJSObject())
                NotifyUtils.addSuccess(TextConstants.Titles.AuthorisationRequest, TextConstants.Notifications.UpdateRequestCreated, NotificationDuration.Standard);
            });
        }

        await this.backToTransaction();
    }

    public populateMappedSecurityObject(selectedtransactionValues: RawGenericTransactionLookup) {
        var transactionsToUpdate = selectedtransactionValues;
        var existingObject = this.selectedSecurityTransactions.find(c => c.rawGenericSecurityTransactionID === transactionsToUpdate.rawGenericSecurityTransactionID);

        if (existingObject) {
            if (this.isBulkSelectAllSecurityTransactions) {
                existingObject.selected = false;
            }
            else {
                this.selectedSecurityTransactions.remove(existingObject);
            }
        } else {
            this.selectedSecurityTransactions.push(transactionsToUpdate);
        }
    }

    public populateMappedObjectCash(selectedtransactionValues: RawGenericTransactionLookup) {
        var transactionsToUpdate = selectedtransactionValues;
        var existingObject = this.selectedCashTransactions.find(c => c.rawGenericCashTransactionID === transactionsToUpdate.rawGenericCashTransactionID);

        if (existingObject) {
            if (this.isBulkSelectAllCashTransactions) {
                existingObject.selected = false;
            }
            else {
                this.selectedCashTransactions.remove(existingObject);
            }
        }
        else {
            this.selectedCashTransactions.push(transactionsToUpdate);
        }
    }

    public async updateSecurityTransactionSelectAllCheckbox(selectAllTransactions: boolean) {
        this.isBulkSelectAllSecurityTransactions = selectAllTransactions;

        if (!selectAllTransactions) {
            this.selectedSecurityTransactions = [];
        }
        this.pageManagerSecurity.data.forEach(transaction => {
            if (selectAllTransactions) {
                const exists = this.selectedSecurityTransactions.some(t => t.rawGenericSecurityTransactionID === transaction.rawGenericSecurityTransactionID);
                if (!exists) {
                    this.selectedSecurityTransactions.push(transaction);
                }
            }
            transaction.selected = selectAllTransactions;
        });
    }

    public async updateCashTransactionSelectAllCheckbox(selectAllTransactions: boolean) {
        this.isBulkSelectAllCashTransactions = selectAllTransactions;

        if (!selectAllTransactions) {
            this.selectedCashTransactions = [];
        }
        this.pageManagerCash.data.forEach(transaction => {
            if (selectAllTransactions) {
                const exists = this.selectedCashTransactions.some(t => t.rawGenericCashTransactionID === transaction.rawGenericCashTransactionID);
                if (!exists) {
                    this.selectedCashTransactions.push(transaction);
                }
            }
            transaction.selected = selectAllTransactions;
        });
    }

    private setupUpdateTransactionCommand(
        command: UpdateTransactionCommand,
        sourceCommand: UpdateTransactionCommand,
        isBulkSelectAll: boolean,
        selectedTransactionItems: RawGenericTransactionLookup[],
        includeOnlySelectedWhenNotBulk: boolean,
        excludedIdSelector: (transaction: RawGenericTransactionLookup) => number,
    ) {
        command.mapFrom(sourceCommand);

        if (isBulkSelectAll) {
            command.transactionInterceptionSearchCriteria = this.transactionInterceptionSearchCriteria;
            command.excludedTransactionIds = Array.from(new Set(
                selectedTransactionItems
                    .filter(transaction => !transaction.selected)
                    .map(excludedIdSelector)
                    .filter(id => id > 0),
            ));
            command.transactions = [];
        }
        else {
            command.excludedTransactionIds = [];
            command.transactions = includeOnlySelectedWhenNotBulk
                ? selectedTransactionItems.filter(transaction => transaction.selected)
                : selectedTransactionItems;
        }

        command.isBulkSelectAll = isBulkSelectAll;
    }

    private afterFetch(result: RawGenericTransactionLookup[], isCashTransaction: boolean) {
        if (isCashTransaction) {
            this.setIsSelectedOnCashPageManagerFetch(result);
        }
        else {
            this.setIsSelectedOnSecurityPageManagerFetch(result);
        }
    }

    public setIsSelectedOnSecurityPageManagerFetch(result: RawGenericTransactionLookup[]) {
        result.forEach((transactionLookup) => {

            const isPresent = this.selectedSecurityTransactions.find(id => id.rawGenericSecurityTransactionID === transactionLookup.rawGenericSecurityTransactionID);

            if (this.isBulkSelectAllSecurityTransactions && !isPresent) {
                this.selectedSecurityTransactions.push(transactionLookup);
                transactionLookup.selected = true;
            }

            if (isPresent && isPresent.selected) {
                transactionLookup.selected = true;
            }
        });
    }

    public setIsSelectedOnCashPageManagerFetch(result: RawGenericTransactionLookup[]) {
        result.forEach((cashTransactionLookup) => {

            const isPresent = this.selectedCashTransactions.find(id => id.rawGenericCashTransactionID === cashTransactionLookup.rawGenericCashTransactionID);

            if (this.isBulkSelectAllCashTransactions && !isPresent) {
                this.selectedCashTransactions.push(cashTransactionLookup);
                cashTransactionLookup.selected = true;
            }

            if (isPresent && isPresent.selected) {
                cashTransactionLookup.selected = true;
            }
        });
    }

    // Adds the counter to the Bulk Action Message.
    public bulkActionTotalResults(isCashTransaction: boolean = false) {
        const totalCount = isCashTransaction
            ? this.pageManagerCash.totalRecords
            : this.pageManagerSecurity.totalRecords;

        const selectedTransactionItems = isCashTransaction
            ? this.selectedCashTransactions
            : this.selectedSecurityTransactions;

        const isBulkSelectAll = isCashTransaction
            ? this.isBulkSelectAllCashTransactions
            : this.isBulkSelectAllSecurityTransactions;

        return isBulkSelectAll
            ? (totalCount - selectedTransactionItems.filter(transaction => !transaction.selected).length)
            : selectedTransactionItems.filter(transaction => transaction.selected).length;
    }

    public bulkUpdateYesNoModal(isCashTransaction: boolean, content: any) {
        ModalUtils.showYesNo(TextConstants.Titles.BulkSelectionUpdate,
            content,
            () => {
                isCashTransaction
                    ? this.showUpdateCashTransactionComponent()
                    : this.showUpdateSecurityTransactionComponent();
            })
    }

    public async downloadTransactionsFile() {
        this.serviceProviderGroupingName = this.transactionInterceptionSearchCriteria.meta.serviceProviderGroupingName.value ?? "";
        await this.taskRunner.run(async () => {
            this.fileDownloadApiClient.downloadTransactionsFile(this.transactionInterceptionSearchCriteria.toJSObject(), this.serviceProviderGroupingName);
        });
    }

    public async downloadCashTransactionsFile() {
        this.serviceProviderGroupingName = this.transactionInterceptionSearchCriteria.meta.serviceProviderGroupingName.value ?? "";
        await this.taskRunner.run(async () => {
            this.fileDownloadApiClient.downloadCashTransactionsFile(this.transactionInterceptionSearchCriteria.toJSObject(), this.serviceProviderGroupingName);
        });
    }

    public async uploadSecurityDocumentFile(fileList: File[] | FileList) {
        if (fileList.length == 0) {
            NotifyUtils.addDanger(TextConstants.Titles.UpdateTransactions, TextConstants.Notifications.UpdateRequestFailed, NotificationDuration.Long);
            return;
        }

        var serviceProviderID = this.transactionInterceptionSearchCriteria.meta.staticServiceProviderFileGroupingID.value;
        var serviceProviderGroupingName = this.transactionInterceptionSearchCriteria.meta.serviceProviderGroupingName.value;
        var csvSecurityComment = this.updateTransactionModalCommand.meta.csvSecurityNotes.value;
        var response: any = (await this.taskRunner.run(async () => this.fileDownloadApiClient.uploadSecurityCSV(fileList, serviceProviderID, csvSecurityComment, serviceProviderGroupingName || ""))).data;
        if (response.includes('Success')) {
            NotifyUtils.addSuccess(TextConstants.Titles.AuthorisationRequest, TextConstants.Notifications.UpdateRequestCreated, NotificationDuration.Standard);
        }
        this.closeCSVModal();
    }

    public async uploadCashDocumentFile(fileList: File[] | FileList) {
        if (fileList.length == 0) {
            NotifyUtils.addDanger(TextConstants.Titles.UpdateTransactions, TextConstants.Notifications.UpdateRequestFailed, NotificationDuration.Long);
            return;
        }
        var serviceProviderGroupingName = this.transactionInterceptionSearchCriteria.meta.serviceProviderGroupingName.value;
        var serviceProviderID = this.transactionInterceptionSearchCriteria.meta.staticServiceProviderFileGroupingID.value;
        var csvCashComment = this.updateTransactionModalCommand.meta.csvCashNotes.value;
        var response: any = (await this.taskRunner.run(async () => this.fileDownloadApiClient.uploadCashCSV(fileList, serviceProviderID, csvCashComment, serviceProviderGroupingName || ""))).data;
        if (response.includes('Success')) {
            NotifyUtils.addSuccess(TextConstants.Titles.AuthorisationRequest, TextConstants.Notifications.UpdateRequestCreated, NotificationDuration.Standard);
        }
        this.closeCSVModal();
    }

    public csvModalFileManager = new Components.FileManager({
        multiple: true,
        accept: "csv/*",
        allowedExtensions: [".csv"],
        onFilesSelected: this.onCsvModalSelected.bind(this)
    });

    public onCsvModalSelected(fileList: File[] | FileList) {
        this.csvModal = Array.from(fileList);
    }

}